<template>
  <div class="flex gap-[0.200rem] flex-nowrap overflow-visible items-center">
    <img
      v-for="(star, index) in starArray"
      :width="size"
      :height="size"
      :key="index"
      :class="`${sizesClass} reverse_in_en select-none object-contain flex-shrink-0`"
      :src="getStarImage(star)"
      alt="Star"
      :draggable="false"
    />
  </div>
</template>
  
  <script>
import emptyStarIcon from "@/assets/images/emptyStar.svg";
import halfStarIcon from "@/assets/images/halfStar.svg";
import fullStarIcon from "@/assets/images/star.svg";

export default {
  props: {
    rating: {
      type: Number,
      required: true
    },
    maxStars: {
      type: Number,
      default: 5
    },
    size: {
      type: Number,
      required: false,
      default: 35
    },
    sizesClass: {
      type: String,
      required: false,
      default: "w-[30px] h-[30px] md:w-[34px] md:h-[34px] lg:w-[35px] lg:h-[35px] 3xl:w-[36px] 3xl:h-[36px]"
    }
  },
  computed: {
    starArray() {
      const stars = [];
      const fullStars = Math.floor(this.rating);
      const hasHalfStar = this.rating % 1 !== 0;

      for (let i = 0; i < fullStars; i++) {
        stars.push(1); // Full star
      }

      if (hasHalfStar) {
        stars.push(0.5); // Half star
      }

      while (stars.length < this.maxStars) {
        stars.push(0); // Empty star
      }

      return stars;
    }
  },
  methods: {
    getStarImage(star) {
      if (star === 1) {
        return fullStarIcon;
      } else if (star === 0.5) {
        return halfStarIcon;
      } else {
        return emptyStarIcon;
      }
    }
  }
};
</script>
  